export default "__VITE_ASSET__AU4AHLB9__"